export * from '../overrides/input-highlight';

// soon to be depricated.
import { InputHighlight } from '../overrides/input-highlight';

export default InputHighlight
